import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Title from 'Root/App/Title'

const CheckInbox = () => (
  <div
    className="flex flex-col items-center text-center gap-6 mx-auto"
    style={{ maxWidth: '408px' }}
  >
    <FontAwesomeIcon icon={faEnvelope} className="w-9 h-auto" />
    <Title size="M">
      <Trans>Controlla la tua casella di posta</Trans>.
    </Title>
    <Title size="XS" className="text-gray-400">
      <Trans>
        Ti abbiamo appena inviato via email un nuovo link magico per accedere.
      </Trans>
    </Title>
  </div>
)

export default CheckInbox
